var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H128V128H0V0ZM69.4589 58.6666H57.851V101.208C57.851 102.463 56.7843 107.608 51.3883 107.357C45.9922 107.106 43.5451 101.082 43.5451 101.082L33.9451 106.98C33.9451 106.98 39.2785 117.898 50.0079 117.898C60.7373 117.898 69.4589 113.882 69.4589 101.208V58.6666ZM114.384 67.5765C110.35 60.5602 103.782 57.6466 96.9412 58.0392C90.1007 58.4318 80.1254 60.9977 79.8745 74.5412C79.6237 88.0846 96.1255 92.8 96.1255 92.8C103.004 95.6933 106.238 97.4064 106.039 101.333C105.295 106.157 102.086 107.42 97.9451 107.42C93.8039 107.42 89.69 105.561 85.8981 100.141L76.3608 105.663C81.4623 113.734 87.4667 118.023 97.9451 117.961C108.424 117.898 118.4 112.502 118.086 101.333C117.773 90.1647 112.376 87.2225 101.459 82.1333C94.2631 79.3103 92.1098 78.0549 91.7334 74.5412C91.3569 71.0275 93.8039 68.3922 97.3177 68.3922C100.831 68.3922 103.372 70.2755 105.161 73.6L114.384 67.5765Z",
    fill: "#F0E3CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.ef5a9d8a13dece25dbb3a3cdf359640a.svg";
export { ForwardRef as ReactComponent };